module.exports = __webpack_public_path__ + "img/tokenCount.4c559892.png";